import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpService } from '../../../core/services/http.service';

import { environment } from 'src/environments/environment';
import { AuthenticationService } from 'src/app/core/services/authentication.service';

/**
 * common library services
 */

@Injectable({
  providedIn: 'root',
})
export class FinancialGoalService {
  constructor(
    private httpService: HttpService,
    private auth: AuthenticationService
  ) {}

  /**
   * Concatenate url with api end points for micro service
   *
   * @param url url to append with api end points
   *
   * @returns url
   */
  private composeUrl(url: string): string {
    return `${environment.host}/${url}`;
  }

  /**
   * To add new programs
   */
  saveFinancial(formData): Observable<any> {
    return this.httpService
      .post('', `${this.composeUrl('financialGoals/opportunities')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  /**
   * To add new programs
   */
  updateFinancial(formData): Observable<any> {
    return this.httpService
      .put('', `${this.composeUrl('financialGoals/opportunities')}`, formData)
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  /// disable opportunity
  disableOpportunity(token, formData): Observable<any> {
    return this.httpService
      .post(
        token,
        `${this.composeUrl('financialGoals/opportunities/disable')} `,
        formData
      )
      .pipe(catchError(this.handleError<any>('addNewProgram')));
  }

  /**
   * To add new programs
   */
  // getFinancial(token, id): Observable<any> {
  //   return this.httpService
  //     .get(
  //       token,
  //       `${this.composeUrl('financialGoals/opportunities?contactId=' + id)}`
  //     )
  //     .pipe(catchError(this.handleError<any>('addNewProgram')));
  // }

  // getIncompleteOpportunity(token, id): Observable<any> {
  //   return this.httpService
  //     .get(
  //       token,
  //       `${this.composeUrl(
  //         'financialGoals/incompleteopportunities?contactId=' + id
  //       )}`
  //     )
  //     .pipe(catchError(this.handleError<any>('addNewProgram')));
  // }

  /**
   * Handle error
   * @param string operation
   * @param T result
   */
  handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      const responseCode = error.status;
      if (error.status == '401' || error.statusText == 'Unauthorized') {
        this.auth.logout();
      }
      // if (ResponseCodes.unauthorized.indexOf(responseCode) > -1) {
      //   this.customEventService.dispatchEvent('unAuthorizeEvent', 'logoutUser');
      // }

      return throwError(error);
    };
  }
}
